module.exports = __webpack_public_path__ + "static/media/UI_example1.c915c672.png";